import { Route, RouteConfig } from 'vue-router';
import { PagePermissionEnum } from '@/types/enum/PermissionEnum';

const patientRoute = [
	{
		path: '/projet/:projectToken/patients',
		name: 'patients',
		props: true,
		component: () => import(
			/* webpackChunkName: "patients" */
			'../../views/patient/PatientsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PATIENT, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'list-patient',
			isConfigurationMandatory: true,
			params: {
				type: 'project'
			}
		}
	},
	{
		path: '/projet/:projectToken/p/facturations/en-cours',
		name: 'billingPatientsCurrent',
		props: true,
		component: () => import(
			/* webpackChunkName: "patients" */
			'../../views/patient/PatientsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PATIENT, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'billing-list-patient-current',
			isConfigurationMandatory: true,
			params: {
				type: 'billing-current'
			}
		}
	},
	{
		path: '/projet/:projectToken/p/facturations/passes',
		name: 'billingPatientsPast',
		props: true,
		component: () => import(
			/* webpackChunkName: "patients" */
			'../../views/patient/PatientsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PATIENT, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'billing-list-patient-past',
			isConfigurationMandatory: true,
			params: {
				type: 'billing-past'
			}
		}
	},
	{
		path: '/projet/:projectToken/patients/current-idel',
		name: 'currentIdel',
		props: true,
		component: () => import(
			/* webpackChunkName: "patients" */
			'../../views/patient/PatientsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PATIENT_IDEL, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'idel-list-patient-current',
			isConfigurationMandatory: true,
			params: {
				type: 'idel-current'
			}
		}
	},
	{
		path: '/projet/:projectToken/patients/past-idel',
		name: 'pastIdel',
		props: true,
		component: () => import(
			/* webpackChunkName: "patients" */
			'../../views/patient/PatientsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PATIENT_IDEL, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'idel-list-patient-past',
			isConfigurationMandatory: true,
			params: {
				type: 'idel-past'
			}
		}
	},
	{
		path: '/projet/:projectToken/validation-forfait-idel/validation',
		name: 'dataLinesIdelValidation',
		props: true,
		component: () => import(
			/* webpackChunkName: "patients" */
			'../../views/patient/PatientsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PATIENT_IDEL_VALIDATOR, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'idel-list-patient-validator-validation',
			isConfigurationMandatory: true,
			params: {
				type: 'idel-validator-validation'
			}
		}
	},
	{
		path: '/projet/:projectToken/validation-forfait-idel/treated',
		name: 'dataLinesIdelTreated',
		props: true,
		component: () => import(
			/* webpackChunkName: "patients" */
			'../../views/patient/PatientsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PATIENT_IDEL_VALIDATOR, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'idel-list-patient-validator-treated',
			isConfigurationMandatory: true,
			params: {
				type: 'idel-validator-treated'
			}
		}
	},
	{
		path: '/projet/:projectToken/liaison-patient-idel',
		name: 'idelLinkPatient',
		props: route => ({
			type: 'idel-user-patient',
			projectToken: route.params.projectToken
		}),
		component: () => import(
			/* webpackChunkName: "idel-actors" */
			'../../views/patient/PatientsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.IDEL_ACTORS_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'link-user-patient',
			isConfigurationMandatory: true,
			params: {
				type: 'idel-user-patient'
			}
		}
	},
	{
		path: '/projet/:projectToken/patient/:patientToken/fiche/:dataLineToken',
		name: 'patientFile',
		props: true,
		component: () => import(
			/* webpackChunkName: "patient_file" */
			'../../views/patient/PatientFile.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PATIENT_FILE, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			}
		}
	},
	{
		path: '/projet/:projectToken/patients/pcr',
		name: 'patientsPcr',
		props: true,
		component: () => import(
			/* webpackChunkName: "patients" */
			'../../views/patient/PatientsView.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.PATIENT_PCR, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'list-patient-pcr',
			isConfigurationMandatory: true,
			params: {
				type: 'pcr-patient'
			}
		}
	}
] as RouteConfig[];

export default patientRoute;
